import { PAYMENT_RULES } from "../constants/payment-rules";

export function normalizePaymentOptions(paymentMethod, language, currency) {
  const rules = PAYMENT_RULES[paymentMethod];
  if (!rules) return { language, currency };

  const lang = rules.languages.includes(language) ? language : rules.languages[0];
  const curr = rules.currencies.includes(currency) ? currency : rules.currencies[0];

  return { language: lang, currency: curr };
}